import { FormTextInputPdf } from '../text-input/FormTextInputPdf'

export const FormNumericInputPdf = (props) => {
  return <FormTextInputPdf {...props} />
}
